import { render, staticRenderFns } from "./CustomerUser.vue?vue&type=template&id=755bcb06&"
import script from "./CustomerUser.vue?vue&type=script&lang=js&"
export * from "./CustomerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports